import {ToggleControl} from '../../../../components/Controls/ToggleControl';
import {EditedProject} from '../../EditedProject';

export function MapDisplayTypeControl({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    return (
        <ToggleControl
            label="Display as polygon"
            checked={project.MapDisplayType}
            onChange={({checked}) =>
                setProjectAndValidate({
                    ...project,
                    MapDisplayType: checked
                })
            }
        />
    );
}
